export enum Collection {
    Users = 'users',
    Locations = 'locations',
    SignIns = 'signins',
    Clubs = 'clubs'
}
